module.exports = __webpack_public_path__ + "static/media/tweets.cdfc51b7.jpg";